import React from 'react'
import { useTranslation } from '../hooks/use-i18n'

interface CreateChooserModalProps {
  onClose: () => void
  onCreateRestaurant: () => void
  onCreateHowIEat: () => void
  isCreatingHowIEat?: boolean
  /** When true, user already has their one personal space — show Open, not Create. */
  hasHowIEatSpace?: boolean
}

const CreateChooserModal: React.FC<CreateChooserModalProps> = ({
  onClose,
  onCreateRestaurant,
  onCreateHowIEat,
  isCreatingHowIEat = false,
  hasHowIEatSpace = false,
}) => {
  const { t } = useTranslation()
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-6 sm:p-8 w-full max-w-md shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-white">{t('dashboard.createChooser.title')}</h2>
          <button
            onClick={onClose}
            className="text-white/60 hover:text-white text-2xl transition-colors"
            type="button"
          >
            ✕
          </button>
        </div>

        <p className="text-white/60 text-sm mb-6">
          {t('dashboard.createChooser.subtitle')}
        </p>

        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={onCreateRestaurant}
            className="w-full text-left bg-[#2a2a2a] hover:bg-[#333] border border-white/10 hover:border-sky-500/40 rounded-xl p-4 transition-all duration-200"
          >
            <div className="flex items-center gap-4">
              <span className="text-3xl">🍽️</span>
              <div>
          <p className="text-white font-semibold">{t('dashboard.createChooser.restaurant.title')}</p>
                <p className="text-white/60 text-sm mt-1">
                  {t('dashboard.createChooser.restaurant.description')}
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={onCreateHowIEat}
            disabled={isCreatingHowIEat}
            className="w-full text-left bg-[#2a2a2a] hover:bg-[#333] border border-white/10 hover:border-emerald-500/40 rounded-xl p-4 transition-all duration-200 disabled:opacity-60"
          >
            <div className="flex items-center gap-4">
              <span className="text-3xl">🥗</span>
              <div>
                <p className="text-white font-semibold">
                  {isCreatingHowIEat ? t('dashboard.createChooser.howIEat.opening') : hasHowIEatSpace ? t('dashboard.createChooser.howIEat.openTitle') : t('dashboard.createChooser.howIEat.title')}
                </p>
                <p className="text-white/60 text-sm mt-1">
                  {hasHowIEatSpace
                    ? t('dashboard.createChooser.howIEat.descriptionExisting')
                    : t('dashboard.createChooser.howIEat.descriptionNew')}
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreateChooserModal
